import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, computed, ElementRef, inject, input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { IntercomService } from '@ideals/services/intercom';
import { InformationStatus } from '@ideals/types';

import { TranslatedContentDirective, TranslatedWrapperDirective } from '../../translated-content';
import { Alert } from '../models';
import { PageMessagesService } from '../page-messages.service';

const ICON_CLASSES = {
  [InformationStatus.Success]: 'icons-check-circle',
  [InformationStatus.Warning]: 'icons-exclamation-triangle',
  [InformationStatus.Danger]: 'icons-exclamation-octagon',
  [InformationStatus.Information]: 'icons-info-circle',
};

@Component({
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ideals-toast',
    '[class.danger]': 'alert().type === InformationStatus.Danger',
    '[class.success]': 'alert().type === InformationStatus.Success',
    '[class.warning]': 'alert().type === InformationStatus.Warning',
    '[class.information]': 'alert().type === InformationStatus.Information',
    '[class]': 'alert().customClass ?? ""',
    'animate.enter': 'ideals-toast-enter',
    'animate.leave': 'ideals-toast-leave',
  },
  imports: [
    NgClass,
    NgTemplateOutlet,
    TranslatePipe,
    TranslatedContentDirective,
    TranslatedWrapperDirective,
  ],
  selector: 'ideals-alert',
  styleUrl: './alert.component.scss',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements AfterViewInit {
  readonly alert = input.required<Alert>();

  readonly #element = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
  readonly #intercomService = inject(IntercomService);
  readonly #pageMessagesService = inject(PageMessagesService);

  protected readonly iconClass = computed(() => ICON_CLASSES[this.alert().type]);

  readonly InformationStatus = InformationStatus;

  ngAfterViewInit(): void {
    this.#element.style.setProperty('--toast-height', `${this.#element.offsetHeight}px`);
  }

  close(): void {
    this.#pageMessagesService.close(this.alert());
  }

  onShowChat(event: MouseEvent): void {
    event.preventDefault();
    this.#intercomService.showChat();
  }
}
